import * as angular from 'angular';
import { debug } from 'console';

'use strict';

angular.module('AdvancedReportsModule')
    .service('AdvancedReportsService', AdvancedReportsService)
    .config(AdvancedReportsConfiguration);

/**
 * Object that will set aHrefSanitizationWhitelist for requests
 * in this factory.
 *
 * @param $compileProvider
 * @constructor
 */
function AdvancedReportsConfiguration($compileProvider: any) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|ftp|mailto|tel|file|blob):/);
}

AdvancedReportsService.$inject = ['$http', 'Configuration'];

function AdvancedReportsService($http, Configuration): void {
    let service = this;

    let apiUrl = Configuration.getApiUrl();

    service.getDataReport = async function (stationID: string, fieldsToReport: string, requestData: string, responseType: string, infoPage: string, dataFilteringData: string) {

        let apiBase = apiUrl + 'get-data-report';
        let config = {
            responseType: responseType,
            params: {
                stationID,
                requestedReportData: requestData,
                fieldsToReport,
                responseType,
                infoPage,
                dataFilteringData
            }
        };
        return $http.get(apiBase, config)
    }

    service.getSummaryCountReport = async function (stationID: string, requestedReportData: string, fieldsToReport: string) {
        let apiBase = apiUrl + 'get-summary-count-report';
        let config = {
            responseType: 'blob',
            params: {
                stationID,
                requestedReportData,
                fieldsToReport
            }
        };
        return $http.get(apiBase, config)
    }

    service.addAutomatedReport = function (newAutomatedReport: any, isCustomFrequency: boolean) {
        const apiBase = apiUrl + 'add-automated-report';

        if (isCustomFrequency) {
            newAutomatedReport.frequency = newAutomatedReport.customFrequency;
            delete newAutomatedReport.customFrequency;

        }
        const data = {
            newAutomatedReport: newAutomatedReport
        };
        return $http.post(apiBase, data);
    }

    /*
    * Create an array of hours in a day
    * @returns {Array}
    */
    service.createHourArray = () => {
        let hours: object[] = [];
        for (let i = 0; i < 24; i++) {
            if (i < 10) {
                hours.push({"value": i, "text": `0${i}:00`});
            } else {
                hours.push({"value": i, "text": `${i}:00`});
            }
        }
        return hours;
    }

    /*
    * Create an array of days in a month
    * @returns {Array}
    */
    service.createDayArray = () => {
        let days: object[] = [];
        for (let i = 1; i <= 31; i++) {
            if (i < 10) {
                days.push({"value": `0${i}`, "text": `0${i}`});
            } else {
                days.push({"value": i, "text": `${i}`});
            }
        }
        days.push({"value": "last", "text": "Last day of month"});
        return days;
    }

    return service;
}
